import { isDevelopment } from './environment';

export type DevWarningHandler = (message: string, duration?: number) => void;

let devWarningHandler: DevWarningHandler | null = null;

/**
 * ToastProvider registers this so services (outside React) can show non-blocking dev warnings.
 * No-ops in production and when the app shell has not registered a handler yet.
 */
export function registerDevWarningHandler(handler: DevWarningHandler | null): void {
  devWarningHandler = handler;
}

export function notifyDevWarning(message: string, duration?: number): void {
  if (!isDevelopment) return;
  devWarningHandler?.(message, duration);
}
